import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-followers-engage',
    templateUrl: './followers-engage.component.html',
    styleUrls: ['./followers-engage.component.scss'],
    standalone: false
})
export class FollowersEngageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
